import { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import Context from "../../common/components/utils/context";

export const Account = ({ page }: IAccountProps) => {
    const navigate = useNavigate();
    const context = useContext(Context);

    if (!page) {
        navigate("/account/profile");
    }

    // TODO: Can this go somewhere else or be generated?
    const menu = [
        {
            id: "AccountProfile",
            slug: "/account/profile",
            title: "Profile",
        },
        {
            id: "AccountInformation",
            slug: "/account/information",
            title: "Information",
        },
        {
            id: "AccountSettings",
            slug: "/account/settings",
            title: "Settings",
        },
    ];

    return (
        <main className="container mx-auto px-4 py-8 mb-auto relative">
            <div className="flex flex-col md:flex-row items-center md:justify-between py-8">
                <div className="md:w-1/5 flex items-center">
                    <img
                        src={context.account.pictureUrl}
                        alt={context.account.username}
                        className="inline h-20 w-20 mr-3 rounded-full border"
                    />
                    <h2>{context.account.username}</h2>
                </div>
            </div>
            <div className="flex flex-col md:flex-row md:justify-around">
                <div className="md:w-1/5 md:mr-6">
                    <ul>
                        {menu.map((item) => (
                            <li key={item.id} className="border-b border-gray-300 p-4 first:pt-0 text-base">
                                <Link
                                to={item.slug}
                                className={item.id === page?.type.name ? "text-gray-900" : "text-gray-400"}>
                                    {item.title}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="md:w-4/5">{page}</div>
            </div>
        </main>
    );
}

interface IAccountProps {
    page?: JSX.Element;
}